import { render } from "./SuperAdministratorProfile.vue?vue&type=template&id=70f963a6"
import script from "./SuperAdministratorProfile.vue?vue&type=script&lang=js"
export * from "./SuperAdministratorProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__